import { render, staticRenderFns } from "./step_4.vue?vue&type=template&id=32d615c8&scoped=true&"
import script from "./step_4.vue?vue&type=script&lang=js&"
export * from "./step_4.vue?vue&type=script&lang=js&"
import style0 from "./step_4.vue?vue&type=style&index=0&id=32d615c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d615c8",
  null
  
)

export default component.exports